module.exports = __webpack_public_path__ + "1791188489487/images/Flaticon.0098bbc.svg";